export default __webpack_public_path__ + "1c174ab01c7b93b9db6c9ff614fcd1fa.png";